import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import LenisProvider, { useLenis } from "@/components/LenisProvider";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { api } from "@/lib/api";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import Contact from "@/pages/Contact";
import Carrinho from "@/pages/Carrinho";
import Perfil from "@/pages/Perfil";
import AuthCallback from "@/pages/AuthCallback";
import Forja from "@/pages/Forja";

const VisitTracker = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        const ref = window.__zfReferrer ?? document.referrer ?? "";
        window.__zfReferrer = "";
        try {
            api.post("/track", { path: pathname, referrer: ref });
        } catch {
            /* rastreio nunca deve quebrar a navegação */
        }
    }, [pathname]);
    useEffect(() => {
        if (document.referrer) window.__zfReferrer = document.referrer;
    }, []);
    return null;
};

const ScrollToTop = () => {
    const { pathname } = useLocation();
    const { lenis } = useLenis();
    useEffect(() => {
        if (lenis) lenis.scrollTo(0, { immediate: true });
        else window.scrollTo(0, 0);
    }, [pathname, lenis]);
    return null;
};

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    render() {
        if (this.state.hasError) {
            return (
                <div className="flex min-h-screen items-center justify-center bg-forge-ink px-6 text-center">
                    <p className="font-display text-lg text-forge-paper">Algo quebrou na forja. Recarregue a página.</p>
                </div>
            );
        }
        return this.props.children;
    }
}

const AppRoutes = () => {
    const location = useLocation();
    // OAuth: process the session_id from the URL fragment FIRST, before any /me check
    if (location.hash?.includes("session_id=")) return <AuthCallback />;
    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/catalogo" element={<Catalog />} />
            <Route path="/contato" element={<Contact />} />
            <Route path="/carrinho" element={<Carrinho />} />
            <Route path="/perfil" element={<Perfil />} />
            <Route path="/forja" element={<Forja />} />
            <Route path="*" element={<Home />} />
        </Routes>
    );
};

function App() {
    return (
        <ErrorBoundary>
            <AuthProvider>
                <CartProvider>
                    <BrowserRouter>
                        <LenisProvider>
                            <ScrollToTop />
                            <VisitTracker />
                            <div className="relative min-h-screen bg-forge-ink font-sans text-forge-paper">
                                <div className="zf-grain" aria-hidden />
                                <Navbar />
                                <main>
                                    <AppRoutes />
                                </main>
                                <Footer />
                                <Toaster
                                    theme="dark"
                                    position="bottom-right"
                                    toastOptions={{
                                        style: {
                                            background: "#121212",
                                            border: "1px solid #2A2A2A",
                                            color: "#F0EFEA",
                                        },
                                    }}
                                />
                            </div>
                        </LenisProvider>
                    </BrowserRouter>
                </CartProvider>
            </AuthProvider>
        </ErrorBoundary>
    );
}

export default App;
